import { client } from "~/clientInstance";

export function resolveUrl(url: string) {
    return url.startsWith("~") || url.startsWith("/") ? client.resolve(url) : url;
}
